import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
    zIndex: 10,
  },
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    scrollbarWidth: 'none',
  },
  rootHeader: {
    display: 'flex',
    alignItems: 'center',
    height: 34,
    padding: '13px 19px',
    backgroundColor: 'rgb(41, 87, 255)',
    borderBottom: `4px solid rgb(255, 240, 0)`,
    left: 0,
    top: 0,
    zIndex: 100,
  },
  logo: {
    width: 40,
    marginRight: 12,
  },
  logoText: {
    color: 'rgb(255, 240, 0)',
    fontFamily: 'BancoDoBrasil Titulos',
    fontSize: 18,
    fontWeight: 'bold',
    marginRight: 16,
  },
  logoArea: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    border: 0,
  },
  logoBorder: {
    borderRight: 'solid 1px rgba(38, 38, 38, 0.25)',
  },
  body: {
    padding: '22px',
    overflow: 'auto',
  },
  gridRoot: {
    marginTop: '10px'
  },
  gridArea: {
    backgroundColor: 'rgb(255, 255, 255)',
    color: 'rgb(38, 38, 38) !important',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    borderRadius: '4px',
    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 1px -1px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 1px 3px 0px'
  },
  clearButton:{
    background: 'none',
    color: 'white',
    border: 'none',
    padding: '0',
    cursor: 'pointer',
    outline: 'inherit'
  },


  // root: {
  //   position: "absolute",
  //   left: "50%",
  //   top: "50%",
  //   width: 400,
  //   transform: "translate(-50%, -50%)",
  // },
  // selected: {
  //   outline: `2px solid ${theme.palette.primary.main}`,
  // },
  // cardHeader: { padding: 8, paddingBottom: 8 },
  // cardRoot: {
  //   boxShadow: '0px 1px 1px rgba(21, 21, 24, 0.18), 0px 0px 1px rgba(25, 25, 28, 0.25)',
  //   '&:hover': {
  //     cursor: 'pointer',
  //     boxShadow:
  //       '0px 6px 8px rgba(24, 24, 27, 0.06), 0px 1px 4px rgba(24, 24, 27, 0.08), 0px 0px 1px rgba(24, 24, 27, 0.08)',
  //   },
  // },
  // cardContent: { padding: '0 8px 8px !important' },
  // footer: {
  //   display: 'flex',
  //   justifyContent: 'flex-end',
  // },
}));

export default useStyles;
